export const approach = (
  current: number,
  target: number,
  dt: number,
  tau: number,
  epsilon = 0.003
): number => {
  const next = current + (target - current) * (1 - Math.exp(-dt / tau));
  return Math.abs(target - next) < epsilon ? target : next;
};
